import React from "react";
import { Provider } from "react-redux";

import StudioCampaignContentSection from "./studio_campaign_content_section.jsx";
import StudioCampaignContentTopBar from "./studio_campaign_content_top_bar.jsx";

import { initializeStore } from "@js/helpers/store.js";

class StudioCampaignContentWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.store = initializeStore(props);
  }

  render() {
    return (
      <Provider store={this.store}>
        <StudioCampaignContentTopBar
          offer_v1_editor={this.props.offer_v1_editor}
          use_v1_editor={this.props.use_v1_editor}
          use_v1_editor_warning={this.props.use_v1_editor_warning}
        />
        <StudioCampaignContentSection
          max_sizes={this.props.max_sizes}
          campaign_id={this.props.campaign_id}
          available_fields={this.props.available_fields}
          forms={this.props.forms}
          use_v1_editor={this.props.use_v1_editor}
        />
      </Provider>
    );
  }
}

export default StudioCampaignContentWrapper;
